'use strict';
/**
 * This service both contains the model for the user profile and handles
 * the communication with the backend to get/modify the persistent data.
 *
 * This service is common to all autoremind modules.
 *
 */
angular.module('autoremind.services')
    .factory('userProfile', ['$rootScope', '$http', '$interval', 'logger', 'angularMomentConfig', 'localStorageService', '$enhancedHttp',
    function ($rootScope, $http, $interval, logger, angularMomentConfig, localStorageService, $enhancedHttp) {
        var userProfile = null; // Initialize to avoid warnings in Eclipse
        userProfile = {
            serviceAlive: true,
            profileModel: {
                "accountstate": "",
                "company": "",
                "address": "",
                "city": "",
                "zip": "",
                "mcc": "",
                "country": "",
                "vat": "",
                "contactemail": "",
                "contactphone": "",
                "maxreschedule": "",
                "intervalstart": "",
                "intervalstop": "",
                "ownedby": "",
                "templates": [],
                "notificationoffsets": [],
                "strategies": []
            },
            userstatuses: [],
            clearModel: function () {
                logger.debug('userProfile.clearModel()');
                userProfile.profileModel = {
                    "accountstate": "",
                    "company": "",
                    "address": "",
                    "city": "",
                    "zip": "",
                    "mcc": "",
                    "country": "",
                    "vat": "",
                    "contactemail": "",
                    "contactphone": "",
                    "maxreschedule": "",
                    "intervalstart": "",
                    "intervalstop": "",
                    "ownedby": "",
                    "templates": [],
                    "notificationoffsets": [],
                    "strategies": []
                };
                userProfile.viewModel.views = {};
            },
            countries: [],
            getCountries: function (gotCountries) {
                logger.debug('getCountries: countries.length=' + userProfile.countries.length);
                if (userProfile.countries.length > 0) {
                    logger.debug('Already loaded countries from JSON file - no need to load again');
                    gotCountries();
                }
                else {
                    logger.debug('Getting countries from JSON file');
                    //TODO: Write test that will validate the JSON file (in test suite)
                    $http.get('assets/countries.json')
                        .then(function (res) {
                        logger.debug('Got list!');
                        userProfile.countries = res.data;
                        gotCountries(); //Async callback
                    });
                }
            },
            getLocale: function (mcc, gotLocale) {
                userProfile.getCountries(function () {
                    logger.debug('countries.length=' + userProfile.countries.length);
                    // Resolve country specific properties (based on mcc)
                    for (var i = 0; i < userProfile.countries.length; i++) {
                        if (userProfile.countries[i].mcc == String(mcc)) {
                            logger.debug('locale(' + i + '): ' + userProfile.countries[i]);
                            gotLocale(userProfile.countries[i]); //Async callback returning locale
                            return;
                        }
                    }
                });
            },
            getProfile: function (successCallback) {
                logger.debug('userProfile.getProfile()...');
                $enhancedHttp({
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    method: 'GET',
                    url: 'servlets/autoremind/profile/'
                })
                    .then(function (data, status) {
                    console.log('userprofile', data);
                    logger.debug('userProfile: Successful getting user profile from server');
                    // Only do something if the callback is in fact a function
                    if (successCallback && typeof (successCallback) === "function") {
                        var chargify;
                        if (userProfile.profileModel.chargify !== undefined) {
                            chargify = userProfile.profileModel.chargify;
                        }
                        userProfile.profileModel = data.account;
                        userProfile.profileModel.chargify = chargify;
                        if (userProfile.profileModel.notificationoffsets !== undefined) {
                            userProfile.profileModel.notificationoffsets.unshift({
                                displayname: "",
                                id: 0
                            });
                        }
                        userProfile.getLocale(data.account.mcc, function (locale) {
                            logger.debug('locale.country=' + locale.country);
                            userProfile.profileModel.country = locale.country;
                            userProfile.profileModel.h24 = locale.h24;
                            logger.debug('Country=' + userProfile.profileModel.country);
                            angularMomentConfig.timezone = userProfile.profileModel.tz;
                            //logger.debug(JSON.stringify(userProfile.profileModel, undefined, 2));
                            successCallback(data, status); //Async callback
                            $rootScope.$broadcast('event:profile-loaded');
                        });
                    }
                    else {
                        $rootScope.$broadcast('event:profile-loaded');
                    }
                    ;
                }, function (data, status) {
                    logger.error('Error getting profile data from server');
                    // TODO: Send event for fail (probably handle on MainController)
                    //if (failCallback && typeof(failCallback) === "function") {
                    //    failCallback(data, status);
                    //}
                });
            },
            // This is called when on successful login
            getProfileIfNotLoaded: function (successCallback) {
                userProfile.isLoggedIn = true;
                logger.debug('userProfile.getProfileIfNotLoaded()...');
                //if (userProfile.profileModel.notificationoffsets.length == 0) {
                if (!userProfile.profileModel || !userProfile.profileModel.loaded) {
                    userProfile.getProfile(function () {
                        userProfile.profileModel.loaded = true;
                        logger.debug('userProfile: Successful loaded/reloaded user profile from server');
                        // Only do something if the callback is in fact a function
                        if (successCallback && typeof (successCallback) === "function") {
                            successCallback(status); //Async callback
                        }
                    });
                }
            },
            saveMaxReschedule: function (maxReschedule) {
                logger.debug('saveMaxReschedule: =' + userProfile.profileModel.maxreschedule);
                var postData = { maxReschedule: Number(userProfile.profileModel.maxreschedule) };
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: 'servlets/autoremind/profile/',
                    data: JSON.stringify(postData)
                });
            },
            getUserStatuses: function () {
                var self = this;
                var url = '/servlets/satellites/userstatuses/';
                $enhancedHttp({
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    method: 'GET',
                    url: url
                })
                    .then(function (data, status) {
                    // console.log('getUserStatuses', self.userstatuses, data.userStatuses);
                    userProfile.userstatuses = [];
                    for (var i in data.userStatuses) {
                        if (data.userStatuses[i].userStatus && data.userStatuses[i].userStatus.length > 0) {
                            userProfile.userstatuses.push({
                                id: data.userStatuses[i].userStatus,
                                name: data.userStatuses[i].userStatus,
                                group: "A",
                                type: 'user',
                                text: 'User: ' + data.userStatuses[i].userStatus
                            });
                        }
                    }
                    // self.userstatuses = data.userStatuses;
                }, function (data, status) {
                });
                // $http({
                //     method: 'GET',
                //     headers: {'Content-Type': 'application/json'},
                //     url: url,
                //     errorMessage: 'Failed getting data from server',
                //     disableErrorDialog: true,
                //     retryBtn: false
                // })
                //     .then(function (result) {
                //
                //     }, function (error) {
                //
                //     })
            },
            /**
             * Model for storing data for all views for the entire app
             */
            viewModel: {},
            stopHandler: undefined,
            isLoggedIn: false,
            logout: function (successCallback, failCallback) {
                userProfile.isLoggedIn = false;
                userProfile.clearModel();
                userProfile.profileModel.loaded = false;
                //TODO: Clear local storage?
            },
            /**
             * Create children of viewModel if not created
             */
            initalizeViewModel: function (model) {
                logger.debug('userProfile.initalizeViewModel()...');
                //if (!angular.isDefined(userProfile.viewModel.views.reminders)) {
                //localStorageService.remove('viewModel');
                //if (userProfile.viewModel == undefined) userProfile.viewModel = {};
                if (userProfile.viewModel.views == undefined) {
                    //localStorageService.add('viewModel', JSON.stringify($scope.viewModel));
                    //var oldData = JSON.parse(localStorageService.get('viewModel'));
                    var oldData = JSON.retrocycle(JSON.parse(localStorageService.get('viewModel')));
                    if (angular.isDefined(oldData) && oldData !== null) {
                        // DISABLE THIS CASE TO AVOID USING STORED DATA (until properly tested!!!)
                        // userProfile.viewModel.views = oldData;
                        userProfile.viewModel.views = {};
                    }
                    else {
                        userProfile.viewModel.views = {};
                    }
                }
                else {
                    // Nothing
                }
                //var obj = userProfile.viewModel.views[model];
                if (!angular.isDefined(userProfile.stopHandler)) {
                    // Start timed function that saves to local storage every 5 seconds
                    userProfile.stopHandler = $interval(function () {
                        if (userProfile.isLoggedIn == true) {
                            //logger.debug('Updating local storage with view model...');
                            //var toSave = JSON.stringify(userProfile.viewModel.views);
                            //12Mar2015                              var toSave = JSON.stringify(JSON.decycle(userProfile.viewModel.views));
                            //12Mar2015                              localStorageService.add('viewModel', toSave);
                        }
                        else {
                            //logger.debug('Skipping update of local storage with view model (because logged out)...');
                        }
                    }, 50000); // TODO: Change to 5000 when we start using this
                }
            }
        };
        // $rootScope.$on('event:auth-loginConfirmed', function() {
        //     logger.info('userProfile: on: event:auth-loginConfirmed - getting user profile if not loaded');
        //     userProfile.getProfileIfNotLoaded( function() {
        //         logger.debug('userProfile: Got user profile');
        //     });
        // });
        $rootScope.$on('event:auth-logout', function () {
            userProfile.logout(function () {
                logger.debug('accountService: notified userProfile about logout');
            });
        });
        return userProfile;
    }]);
//# sourceMappingURL=userprofile.service.js.map